import { render, staticRenderFns } from "./form-builder.html?vue&type=template&id=52f4059c&scoped=true&external"
import script from "./form-builder.js?vue&type=script&lang=js&external"
export * from "./form-builder.js?vue&type=script&lang=js&external"
import style0 from "./form-builder.scss?vue&type=style&index=0&id=52f4059c&prod&scoped=true&lang=scss&external"
import style1 from "./form-builder-print.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f4059c",
  null
  
)

export default component.exports